import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'CLEAR LABELED DIAGRAMS.', 'STEP-BY-STEP TECHNIQUES.', '❌/✅ COMPARISONS.', 'READY PRACTICE PROJECTS.', 'CLEAR ASSESSMENT CRITERIA.', 'READY-TO-TEACH CLASSES.', 'BETTER CLASS PREPARATION.'];
const alreadyHave = ['You already have the safety, equipment and metal preparation visuals.', 'You already have the MIG/MAG setup, settings and technique guides.', 'You already have the TIG tungsten, torch and filler sequences.', 'You already have the stick electrode, position and structural methods.', 'You already have the blueprint, welding symbol and inspection workflows.', 'You already have the lesson plans, course programs and practical assessments.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-[#D5DAE0]" data-id="element-68" data-mp="216e4laqc5rd3">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-69" data-mp="1wc044twtgu1k">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#16191E] mb-6 uppercase" data-id="element-70" data-mp="1v6bd98x5r3qm">
          You Don&apos;t Need More Scattered <span className="text-[#E8590C]" data-id="element-71" data-mp="203l8543bg7lu">Welding Teaching Resources.</span>
        </h2>
        <p className="text-xl text-slate-700/80 mb-5" data-id="element-72" data-mp="1l6kkpcs5qyt6">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-73" data-mp="1q6gopc0uuq8q">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-[#16191E] tracking-wide" data-id="element-74" data-mp="1c7pc5u1n5cmp">
              {need}
            </li>)}
        </ul>
        <div className="bg-[#F3F5F7] border border-[#D5DAE0] rounded-2xl p-8 text-lg text-slate-700 space-y-2 text-left sm:text-center" data-id="element-75" data-mp="1h7v4lcfqj35u">
          <p className="mb-4" data-id="element-76" data-mp="3bkbbmfgculbr">
            With WELDING INSTRUCTOR ATLAS, you don&apos;t start every class searching through
            books, handouts, videos and old notes.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-[#16191E] font-semibold flex items-center sm:justify-center gap-2" data-id="element-77" data-mp="35287e3x6aui3">
              <Check size={18} className="text-[#E8590C] shrink-0" aria-hidden="true" data-id="element-78" data-mp="2v652iqaxshrg" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-79" data-mp="3ss2j2i5rad0r">
            And with the five exclusive bonuses, you also have machine settings and parameters quick-reference charts,
            demonstration lesson scripts, a practice projects and coupon exercise workbook, weld defect identification
            flashcards, and competency checklists, rubrics and certificates to help you plan, teach, correct and assess
            your students.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#16191E]" data-id="element-80" data-mp="fgagimdkjvmg">
            YOU ALREADY HAVE <span className="text-[#E8590C]" data-id="element-81" data-mp="hyx3104sj4zn">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}